import React, { ReactElement, ReactNode } from "react";
import { useStyles } from "./FormLayoutBody.styles";

interface MainLayoutProps {
	children: ReactNode;
}

const FormLayoutBody = ({ children }: MainLayoutProps): ReactElement => {
	const styles = useStyles();

	return <div className={styles.formBody}>{children}</div>;
};
export default FormLayoutBody;
